/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Event_Group_ToastInputs */

const en_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event group selected.`)
};

const fr_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe d'evenements selectionne.`)
};

const de_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ereignisgruppe ausgewählt.`)
};

const it_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo di eventi selezionato.`)
};

const ru_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий не выбрана.`)
};

const es_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún grupo de eventos seleccionado.`)
};

const zh_cn2_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择事件组。`)
};

const ja_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループが選択されていません。`)
};

const hi_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट समूह चयनित नहीं है।`)
};

const pt_pt2_error_nav_no_event_group_toast = /** @type {(inputs: Error_Nav_No_Event_Group_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum grupo de eventos selecionado.`)
};

/**
* | output |
* | --- |
* | "No event group selected." |
*
* @param {Error_Nav_No_Event_Group_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_event_group_toast = /** @type {((inputs?: Error_Nav_No_Event_Group_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Event_Group_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_event_group_toast(inputs)
	if (locale === "de") return de_error_nav_no_event_group_toast(inputs)
	if (locale === "it") return it_error_nav_no_event_group_toast(inputs)
	if (locale === "ru") return ru_error_nav_no_event_group_toast(inputs)
	if (locale === "es") return es_error_nav_no_event_group_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_event_group_toast(inputs)
	if (locale === "ja") return ja_error_nav_no_event_group_toast(inputs)
	if (locale === "hi") return hi_error_nav_no_event_group_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_no_event_group_toast(inputs)
	return en_error_nav_no_event_group_toast(inputs)
});